module.exports = __webpack_public_path__ + "img/pixel_create.5c82893c.svg";